import React from 'react'
import styled from 'styled-components'
import PlaceholderImage from "../../assets/images/placeholder-image.jpg";
import { useTheme } from '../../middleware/ThemeContext';
import PinIcon from '../../assets/icons/PinIcon';
import FieldWithRadio from './FieldWithRadio';
import { Data } from '../../types/types';

interface fieldData {
    label: string;
    key: string;
}

interface MergeSingleResult {
    scope?: 'CONTACTS' | 'ORGANIZATION';
    columns: fieldData[];
    data: any[];
    dynamicFields: {
        submissionFields: { id: number; name: string }[];
        crmFieldValues: { id: number; name: string }[];
    };
    initialState: Data;
    handelChange: (e: React.ChangeEvent<any>) => void;
    onClick: (field_key: string, value: string) => void;
    handlePrimaryID: (newid: number, image: string) => void;
    handleMeta: (key: string, value: any) => void;
    handleFormFields: (data_id: number, id: number, name: string, value: string) => void;
    onSelectAllFields?: (contact: any) => void;
}

interface Role {
  id: number;
  name: string;
}

interface ContactRole {
  id: number;
  role: Role;
}

interface SubmissionValue {
  field: Role;
  value: string;
}

function getOrganizationNames(organizations: {organization: {id: number, name: string}}[] = []): string {
    if(organizations.length == 0) return '-';
  const uniqueNames = Array.from(
    new Set(
      organizations
        .map((item) => item?.organization?.name)
        .filter(Boolean) as string[]
    )
  );

  return uniqueNames.join(", ");
}

function getOrganizationsIDS(organizations: {organization: {id: number, name: string}}[]): number[] {
  const uniqueIds = new Set(
    organizations
      .map(item => item.organization?.id)
      .filter((id): id is number => id !== undefined) // ensure only numbers
  );

  return Array.from(uniqueIds);
}

function getRoleNames(contactRoles: ContactRole[] = []): string {
    if(contactRoles.length == 0) return '-';
  return contactRoles
    .map((item) => item.role?.name)
    .filter(Boolean)
    .join(', ');
}

function getRoleIDS(contactRoles: { id: number, role: { id: number } }[]): number[] {
  return contactRoles
    .map(item => item.role?.id);
}

function getOrgData(orgData: {id: number, name: string, image: string}) : 
{ id: number; name: string; image: string | null } {
    return {
        id: orgData.id,
        name: orgData.name,
        image: orgData.image
    }
}

const getFieldValue = (item: any, key: string): string => {
  const value = item?.[key];
  if (typeof value === 'object' && value !== null) return '-';
  return value !== undefined && value !== null ? value : '-';
};

const arraysAreEqual = (a: any[], b: any[]) => {
    if (a.length === 0 && b.length === 0) return false;
  return (
    a.length === b.length &&
    a.every((value, index) => value === b[index])
  );
};

const MergeSingleResult:React.FC<MergeSingleResult> = ({ scope, columns, data, dynamicFields, initialState, handlePrimaryID, handleMeta, handleFormFields, handelChange, onClick, onSelectAllFields }) => {
    const {theme} = useTheme();
    let columnsClass: string;
    if(data?.length === 2){
        columnsClass = 'col-6';
    } else if (data?.length === 3) {
        columnsClass = 'col-4';
    } else if (data?.length > 3) {
        columnsClass = 'col-3';
    }
    
  return (
    <ResultContainer theme={theme}>
        {data?.map((item) => (
            
            <SingleResult theme={theme} className={columnsClass} key={item.id}>
                <ProfileContainer theme={theme} onClick={() => {handlePrimaryID(item.id, item.image); onClick('dataID', item.id); onSelectAllFields?.(item);}}>
                    <div className=" d-flex">
                        <ProfileImage>
                        <img
                            src={item.signedUrl || PlaceholderImage}
                            alt={item.image}
                            onError={(e) => {
                            (e.target as HTMLImageElement).src = PlaceholderImage;
                            }}
                        />
                        </ProfileImage>
                        <NameContainer theme={theme}>
                            <span style={{ fontWeight: 600 }}>
                                {scope === 'CONTACTS' ? 
                                [item?.firstName, item?.lastName].filter(Boolean).join(" ") || null
                                : scope === 'ORGANIZATION' ? item.name : null} 
                            </span>
                            <IdText theme={theme}>Id: {item.id}</IdText>
                        </NameContainer>
                    </div>
                    <div>
                        <PinIcon color={initialState.metaData.id === item.id ? theme.CorporateTheme.colors.primary : theme.CorporateTheme.colors.border} />
                        <input 
                        type='radio' 
                        name={'dataID'} 
                        value={item.id} 
                        checked={initialState.metaData.id === item.id ? true : false} 
                        onChange={handelChange} 
                        style={{ display: 'none' }}   />
                    </div>
                </ProfileContainer>
                <Fields theme={theme}>
                    {columns.map((column: fieldData) => {
                        
                        let meta_active = false;
                        if (['firstName', 'lastName', 'fullName', 'email', 'name'].includes(column.key)) {
                            type MetaKeys = 'firstName' | 'lastName' | 'email' | 'name';
                            const metaValue = initialState.metaData[column.key as MetaKeys];
                            meta_active = `${metaValue?.data_id}_${metaValue?.value}` === `${item.id}_${getFieldValue(item, column.key)}`;
                        }

                        return (
                        column.key === 'contactOrganizations' ?
                            <FieldWithRadio 
                                key={column.key} 
                                label={column.label} 
                                // data={item[column.key]?.name ? item[column.key]?.name : '-'} 
                                data={item[column.key] ? getOrganizationNames(item[column.key]) : '-'} 
                                data_id={item.id}
                                field_key={column.key} 
                                organizationData={{
                                    data_id: item.id,
                                    orgIds: item[column.key] ? getOrganizationsIDS(item[column.key]) : null,
                                    orgNames: item[column.key] ? getOrganizationNames(item[column.key]) : '',
                                    // image: item[column.key] ? item[column.key].image : '',
                                }}
                                updateMeta={handleMeta} 
                                isActive={(initialState?.metaData?.contactOrganizations?.data_id+'_'+initialState?.metaData?.contactOrganizations?.orgNames === item.id+'_'+getOrganizationNames(item[column.key])) ? true : false}
                                handelChange={handelChange}
                                onClick={onClick}
                            />
                        // : column.key === 'contactRoles' ? 
                        
                        //     <FieldWithRadio 
                        //         key={column.key} 
                        //         label={column.label} 
                        //         data={item[column.key] ? getRoleNames(item[column.key]) : '-'} 
                        //         data_id={item.id}
                        //         field_key={column.key} 
                        //         rolesData={{
                        //             data_id: item.id,
                        //             roleids: item[column.key] ? getRoleIDS(item[column.key]) : [],
                        //             roleNames: item[column.key] ? getRoleNames(item[column.key]) : '-',
                        //         }}
                        //         updateMeta={handleMeta} 
                        //         isActive={initialState?.metaData?.contactRoles?.data_id+'_'+initialState?.metaData?.contactRoles?.roleNames === item.id+'_'+getRoleNames(item[column.key]) ? true : false}
                        //         handelChange={handelChange}
                        //         onClick={onClick}
                        //     />
                        :
                            <FieldWithRadio 
                                key={column.key} 
                                label={column.label} 
                                data={getFieldValue(item, column.key)} 
                                data_id={item.id}
                                field_key={column.key} 
                                updateMeta={handleMeta} 
                                isActive={ meta_active }
                                handelChange={handelChange}
                                onClick={onClick}
                            />
                    )})}
                    {dynamicFields?.submissionFields.map((fieldName) => {
                        const matchedField = item?.cfr?.formSubmissions?.submissionValues?.find(
                            (submission: SubmissionValue) => submission.field?.id === fieldName.id
                        );
                        
                        const fieldData = {
                            id: matchedField?.field?.id,
                            name: matchedField?.field?.name,
                            data_type: matchedField?.field?.dataType,
                            value: matchedField?.value,
                        }
                        const exists = initialState.formSubmissions.some(field =>
                            field.id === fieldData.id &&
                            field.name === fieldData.name &&
                            field.data_id+'_'+field.value === item.id+'_'+fieldData.value
                        );

                        return (
                            <FieldWithRadio
                            key={fieldName.id}
                            label={fieldName.name}
                            data={matchedField ? matchedField.value : '-'}
                            data_id={item.id}
                            field_key={fieldName.name+'_'+fieldName.id}
                            fieldData={fieldData}
                            updateFields={handleFormFields}
                            isActive={exists}
                            handelChange={handelChange}
                            onClick={onClick}
                            />
                        );
                    })}
                    {dynamicFields?.crmFieldValues.map((fieldName) => {
                        const matchedField = item?.cfr?.crmFieldValues?.find(
                            (submission: SubmissionValue) => submission.field?.id === fieldName.id
                        );
                        
                        const fieldData = {
                            id: matchedField?.field?.id,
                            name: matchedField?.field?.name,
                            data_type: matchedField?.field?.dataType,
                            value: matchedField?.value,
                        }
                        const exists = initialState.formSubmissions.some(field =>
                            field.id === fieldData.id &&
                            field.name === fieldData.name &&
                            field.data_id+'_'+field.value === item.id+'_'+fieldData.value
                        );

                        return (
                            <FieldWithRadio
                                key={fieldName.id}
                                label={fieldName.name}
                                data={matchedField ? matchedField.value : '-'}
                                data_id={item.id}
                                field_key={fieldName.name+'_'+fieldName.id}
                                fieldData={fieldData}
                                updateFields={handleFormFields}
                                isActive={exists}
                                handelChange={handelChange}
                                onClick={onClick}
                            />
                        );
                    })}
                </Fields>
            </SingleResult>
            
        ))}
    </ResultContainer>
  )
}

const ResultContainer = styled.div`
    display: flex;
    // overflow-y: auto;
    // overflow-x: auto;
    & > div:not(:last-child){
        border-right: 1px solid ${({theme}) => theme.CorporateTheme.colors.border};
    }
`;
const SingleResult = styled.div`
    padding: 0px 12px;
    // border-right: 1px solid ${({theme}) => theme.CorporateTheme.colors.border};
`;

const ProfileContainer = styled.div`
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid ${({theme}) => theme.CorporateTheme.colors.border};
    margin-bottom: 10px;
    padding: 10px 0px;
    position: sticky;
    top: 0;
    background-color: ${({theme}) => theme.colors.contentBackground};
`;

const ProfileImage = styled.div`
    margin-right: 10px;
    & img {
        width: 34px;
        height: 34px;
        border-radius: 50%;
    }
`;

const NameContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  fontSize: '16px',
  color: theme.CorporateTheme.colors.textPrimary,
  fontFamily: '"Raleway", sans-serif',
  lineHeight: '20px',
//   gap: CorporateTheme.spacing.xs,
}));

const IdText = styled('span')(({ theme }) => ({
  fontSize: '14px',
  fontWeight: 400,
  fontFamily: '"Lato", sans-serif',
  color: theme.CorporateTheme.colors.textSecondary,
  textAlign: 'left',
}));

const Fields = styled.div`
    & > div:not(:last-child) {
        border-bottom: 1px solid ${({theme}) => theme.CorporateTheme.colors.border};
    }
`;

const FieldCon = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 5px;
    cursor: pointer;
    &:hover {
        background-color: ${({theme}) => theme.CorporateTheme.colors.bannerBg};
    }
    &.active {
        background-color: ${({theme}) => theme.CorporateTheme.colors.bannerBg};
        border-radius: 5px;
    }
    // margin: 10px 0px;
`;

export default MergeSingleResult